interface StarRatingProps {
  rating: number;
  maxRating?: number;
}

const StarIcon = ({ filled }: { filled: boolean }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.71926 1.34154C5.95926 0.60474 7.00166 0.60474 7.24086 1.34154L8.09686 3.97514C8.14916 4.13553 8.25082 4.27528 8.38731 4.37442C8.52381 4.47356 8.68816 4.52702 8.85686 4.52714H11.6265C12.4017 4.52714 12.7233 5.51914 12.0969 5.97514L9.85686 7.60234C9.72008 7.70156 9.61824 7.84155 9.56592 8.00222C9.51361 8.1629 9.51352 8.33601 9.56566 8.49674L10.4217 11.1303C10.6617 11.8671 9.81766 12.4807 9.18966 12.0247L6.94966 10.3975C6.81302 10.2983 6.6485 10.2449 6.47966 10.2449C6.31081 10.2449 6.14629 10.2983 6.00966 10.3975L3.76966 12.0247C3.14246 12.4807 2.29926 11.8671 2.53846 11.1303L3.39446 8.49674C3.4466 8.33601 3.4465 8.1629 3.39419 8.00222C3.34188 7.84155 3.24003 7.70156 3.10326 7.60234L0.864057 5.97594C0.237657 5.51994 0.560057 4.52794 1.33446 4.52794H4.10326C4.2721 4.52798 4.43662 4.47461 4.57328 4.37546C4.70993 4.27631 4.81172 4.13646 4.86406 3.97594L5.72006 1.34234L5.71926 1.34154Z"
      fill={filled ? "#FFB800" : "#E5E7EB"}
    />
  </svg>
);

export default function StarRating({ rating, maxRating = 5 }: StarRatingProps) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  return (
    <div className="flex items-center gap-[2px]">
      {[...Array(maxRating)].map((e, index) => (
        <StarIcon
          key={`star-${index}-${maxRating}`}
          filled={index < fullStars || (index === fullStars && hasHalfStar)}
        />
      ))}
    </div>
  );
}
